export default "__VITE_ASSET__c6d790bc__"